var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.067,
    height: 17.641,
    viewBox: "0 0 19.067 17.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M16.114,13.765A3.083,3.083,0,1,0,13,10.651,3.119,3.119,0,0,0,16.114,13.765Zm-.064-4.894h0a1.844,1.844,0,0,1,1.843,1.843,1.812,1.812,0,0,1-3.623,0,1.832,1.832,0,0,1,1.78-1.843Z",
    transform: "translate(-6.644 -5.467)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M29.529,15.786A6.293,6.293,0,0,0,25.08,14.2h-.508A4.237,4.237,0,0,1,24,15.532a6.166,6.166,0,0,1,1.08-.064,5.286,5.286,0,0,1,3.368,1.017v4.576H29.72V15.977l-.191-.191Z",
    transform: "translate(-10.653 -7.87)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M22.89,6.524a1.552,1.552,0,1,1,2.86,1.208,1.586,1.586,0,0,1-1.4.953,1.082,1.082,0,0,1-.445-.064,4.5,4.5,0,0,1,.064.89v.381c.127,0,.254.064.381.064A2.828,2.828,0,0,0,24.415,4.3,2.725,2.725,0,0,0,22,5.7a2.713,2.713,0,0,1,.89.826Z",
    transform: "translate(-9.924 -4.264)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M8.72,15.632A4.237,4.237,0,0,1,8.148,14.3H7.64a6.54,6.54,0,0,0-4.449,1.525L3,16.013V21.1H4.271V16.522A5.4,5.4,0,0,1,7.64,15.5,5.6,5.6,0,0,1,8.72,15.632Z",
    transform: "translate(-3 -7.906)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M8.676,9.872a.806.806,0,0,0,.381-.064V9.428a3.908,3.908,0,0,1,.064-.89,1.082,1.082,0,0,1-.445.064,1.525,1.525,0,0,1,0-3.051,1.606,1.606,0,0,1,1.462.953,6.327,6.327,0,0,1,.953-.89A2.823,2.823,0,1,0,8.676,9.872Z",
    transform: "translate(-4.036 -4.244)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M20.232,21.35l-.127-.191A6.415,6.415,0,0,0,15.148,19a6.547,6.547,0,0,0-5.021,2.161L10,21.35v4.83a1.071,1.071,0,0,0,1.08,1.08h8.135a1.114,1.114,0,0,0,1.08-1.08V21.35Zm-1.271,4.64h-7.69V21.794a5.424,5.424,0,0,1,3.877-1.525,5.126,5.126,0,0,1,3.813,1.525Z",
    transform: "translate(-5.551 -9.62)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdUserManagement);
export default __webpack_public_path__ + "static/media/ad-user-management.b957bf4db967553ddfca310ef2c4e0f0.svg";
export { ForwardRef as ReactComponent };